'use strict';
import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
gsap.registerPlugin(ScrollTrigger);

$(document).ready(function () {
    const header = $('.header');
    let shopBtn = window.innerWidth > 991 ? $('#header-holder') : $('#header-shop-btn');
    const menu = $('#header-menu');
    const filters = $('#collections-menu');

    window.addEventListener('resize', () => {
        if (window.innerWidth > 991) {
            shopBtn = $('#header-holder');
        } else {
            shopBtn = $('#header-shop-btn');
        }
    });

    shopBtn.click(() => {
        if (header.hasClass('header--active')) {
            shopBtn.removeClass('header__menu-link--active');
            menu.fadeOut();
            filters.fadeOut();

            const scrollY = document.body.style.top;
            document.body.style.position = '';
            document.body.style.top = '';
            window.scrollTo(0, parseInt(scrollY || '0') * -1);

            setTimeout(() => {
                header.removeClass('header--active');
                header.removeClass('header--small');
            }, 16);
        } else {
            shopBtn.addClass('header__menu-link--active');
            header.addClass('header--active');
            menu.fadeIn();

            const scrollY = window.pageYOffset || document.documentElement.scrollTop;
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollY}px`;

            if (header.height() * 2 < scrollY) header.addClass('header--small');
        }
    });

    const items = $('#header-shop-mobile-btn, .header__mobile-shop-tag-title');
    items.each(function (index) { // eslint-disable-line no-unused-vars
        const self = $(this);
        const clickElement = self;
        const collapsibleElement = self.parent().find('.collapsible-el').first();

        let classes = clickElement.attr('class');

        this.tl = gsap.timeline({
            reversed: true,
            paused: true
        });

        this.tl.fromTo(collapsibleElement, { duration: 0.3, height: '0', ease: 'power3.out' }, { height: 'auto' }, 'animate');
        this.tl.fromTo(clickElement, { duration: 0.3, className: classes }, { className: classes + ' open' }, 'animate');

        clickElement.click(() => {
            this.tl.reversed() ? this.tl.play() : this.tl.reverse();
        });
    });

    let resizeTimer = null;
    window.addEventListener('resize', resize, true);
    function resize () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            items.each(function () {
                this.tl.invalidate();
            });
        }, 250);
    }

    initHeader(header);
});

function initHeader (header) {
    ScrollTrigger.create({
        start: 'top top',
        end: () => header.height(),
        onLeave: () => {
            if (!header.hasClass('header--active')) gsap.set(header, { y: '-100%' });
        },
        onEnterBack: () => {
            gsap.set(header, { clearProps: 'transform' });
            header.removeClass('header--scrolling');
        },
        onRefresh: () => {
            if ((window.pageYOffset || document.documentElement.scrollTop) > header.height()) header.addClass('header--scrolling');
        }
    });

    ScrollTrigger.create({
        start: () => header.height() * 2,
        end: 'bottom bottom',
        onEnter: () => {
            header.addClass('header--scrolling');
            gsap.set(header, { clearProps: 'transform' });
        },
        onUpdate: self => {
            if (!header.hasClass('header--active')) (self.progress === 0 || self.direction > 0) ? header.removeClass('header--visible') : header.addClass('header--visible');
        }
    });
}
